import { render, staticRenderFns } from "./URegisterInfoEdit.vue?vue&type=template&id=a21493fe&scoped=true&"
import script from "./URegisterInfoEdit.vue?vue&type=script&lang=ts&"
export * from "./URegisterInfoEdit.vue?vue&type=script&lang=ts&"
import style0 from "./URegisterInfoEdit.vue?vue&type=style&index=0&id=a21493fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a21493fe",
  null
  
)

export default component.exports